module.exports = __webpack_public_path__ + "static/city_step06-2d89f5d365ae651f4a441d23e5807c7d.png";